// A line of the site's copy with its figures marked «like this».
//
// The design writes figures inline in Latin digits and sets them in mono, left
// to right, inside Arabic sentences. Marking the runs keeps each line one
// readable string in copy.ts instead of a list of fragments.

export interface Part {
	text: string;
	figure: boolean;
}

export function parts(line: string): Part[] {
	return line
		.split(/«([^»]+)»/)
		.map((text, index) => ({ text, figure: index % 2 === 1 }))
		.filter((part) => part.text !== '');
}
